import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import GameFlowEvent from "../controller/GameFlowEvent";
import AbstractCollaborationScreenMediator from "./AbstractCollaborationScreenMediator";

export default class IntroScreenMediator extends AbstractCollaborationScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets  
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets);
    }

    initialize() {
        super.initialize();

        this._buttonStart = this.createButton(this._target.button, this._handleNextClick.bind(this), this.getText("intro.buttonStart"));
        this._buttonPrev = this.createButton(this._target.prevButton, this._handlePrevClick.bind(this), this.getText("intro.buttonPrev"));
        this._buttonNext = this.createButton(this._target.nextButton, this._handleNextClick.bind(this), this.getText("intro.buttonNext"));

        this.anchorObject(this._target.textPanel, Anchor.T);
        this.anchorObject(this._target.prevButton, Anchor.B);
        this.anchorObject(this._target.nextButton, Anchor.B);
        this.anchorObject(this._target.button, Anchor.B);

        this._numPages = this._target.totalFrames;
        this._showPage(0);
    }

    _showPage(index) {
        this._pageIndex = index;
        this._target.gotoAndStop(index);
        this._target.textPanel.gotoAndStop(index);
        const prefix = "intro.page" + (this._pageIndex + 1);
        this._target.textPanel.bodyTextfield.text = this.getText(prefix + ".body");
        if (this._target.textPanel.titleTextfield.visible) {
            this._target.textPanel.titleTextfield.text = this.getText(prefix + ".title");
        }
        this._buttonPrev.setEnabled(this._pageIndex > 0);
        const isLast = index == this._numPages - 1;
        this._buttonNext.setVisible(!isLast);
        this._buttonStart.setVisible(isLast);
    }

    _handlePrevClick(e) {
        if (this._pageIndex > 0) {
            this._showPage(this._pageIndex - 1);
        }
    }

    _handleNextClick(e) {
        if (this._pageIndex < this._numPages - 1) {
            this._showPage(this._pageIndex + 1);
        } else {
            this._buttonNext.setEnabled(false);
            this._buttonPrev.setEnabled(false);
            this._buttonStart.setEnabled(false);
            this._fadeOut(() => {
                this.dispatch(GameFlowEvent.INTRO_COMPLETED);
            });
        }
    }
}
